/**
 * Keeps freemium cart flags, claim CTA, header cart bubble, and cart page line items
 * aligned with the server after cart updates and when returning via history (back/forward),
 * including bfcache restores.
 */
(function () {
  function setCartBubbleSuppress(active) {
    try {
      document.documentElement.classList.toggle('ds2-cart-bubble-suppress', !!active);
    } catch (e) {}
  }

  function setCartPageSyncing(active) {
    try {
      document.documentElement.classList.toggle('ds2-cart-page-syncing', !!active);
    } catch (e) {}
  }

  function isCartPage() {
    return !!(document.querySelector('cart-items') && document.getElementById('main-cart-items'));
  }

  function isCartPath() {
    try {
      var cartPath = (window.routes && window.routes.cart_url) || '/cart';
      var normalizedCart = cartPath.replace(/\/$/, '');
      var normalizedCurrent = (location.pathname || '').replace(/\/$/, '');
      return normalizedCurrent === normalizedCart || normalizedCurrent.endsWith(normalizedCart);
    } catch (e) {
      return (location.pathname || '').replace(/\/$/, '').endsWith('/cart');
    }
  }

  function replaceElementFromSectionHtml(sectionHtml, selector) {
    if (!sectionHtml) return;
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var source = doc.querySelector(selector);
    var target = document.querySelector(selector);
    if (source && target) target.replaceWith(source);
  }

  function clearStuckCartUiState() {
    document.querySelectorAll('.cart-item .loading-overlay').forEach(function (overlay) {
      overlay.classList.add('hidden');
    });
    var mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');
  }

  function reinitCartQuantityUi() {
    document.dispatchEvent(new CustomEvent('ds2:cart-page-refreshed'));
    return Promise.resolve();
  }

  function cartHasFreePremVisualizationSku(cart) {
    if (!cart || !Array.isArray(cart.items) || !window.PREM_REPORT) return false;
    return cart.items.some(function (item) {
      return item.sku === window.PREM_REPORT;
    });
  }

  function applyClaimButtonState(hasFreeSku) {
    var claimBtn = document.querySelector('.claim-button');
    if (!claimBtn) return;
    if (hasFreeSku) {
      claimBtn.disabled = true;
      claimBtn.style.backgroundColor = '#cecece';
      claimBtn.textContent = 'Added to cart';
      claimBtn.style.cursor = 'default';
    } else {
      claimBtn.disabled = false;
      claimBtn.style.backgroundColor = '';
      claimBtn.textContent = 'CLAIM YOUR FREE SUBSCRIPTION';
      claimBtn.style.cursor = '';
    }
  }

  window.ds2SyncPremVisualizationCartFlags = function (cart) {
    var hasFree = cartHasFreePremVisualizationSku(cart);
    if (hasFree) {
      localStorage.setItem('hasFreeSubscriptionItem', 'true');
    } else {
      localStorage.removeItem('hasFreeSubscriptionItem');
    }
    applyClaimButtonState(hasFree);
  };

  window.ds2RefreshHeaderCartIcon = function () {
    return fetch('/?sections=cart-icon-bubble', { cache: 'no-store' })
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        var html = sections && sections['cart-icon-bubble'];
        if (!html) return;
        var el = document.getElementById('cart-icon-bubble');
        if (!el) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sectionEl = doc.querySelector('.shopify-section');
        if (!sectionEl) return;
        el.innerHTML = sectionEl.innerHTML;
      })
      .catch(function () {});
  };
  window.ds2RefreshCartPage = function () {
    if (!isCartPath() || !isCartPage()) return Promise.resolve();

    var mainCartItems = document.getElementById('main-cart-items');
    var mainCartFooter = document.getElementById('main-cart-footer');
    if (!mainCartItems || !mainCartFooter) return Promise.resolve();

    var itemsSectionId = mainCartItems.dataset.id;
    var footerSectionId = mainCartFooter.dataset.id;
    if (!itemsSectionId || !footerSectionId) return Promise.resolve();

    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    setCartPageSyncing(true);

    return fetch(
      cartUrl + '?sections=' + encodeURIComponent(itemsSectionId) + ',' + encodeURIComponent(footerSectionId),
      { cache: 'no-store' }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        if (!sections) return;
        replaceElementFromSectionHtml(sections[itemsSectionId], 'cart-items');
        replaceElementFromSectionHtml(sections[footerSectionId], '#main-cart-footer');
        return reinitCartQuantityUi();
      })
      .catch(function () {
        return reinitCartQuantityUi();
      })
      .finally(function () {
        setCartPageSyncing(false);
      });
  };

  function shouldSyncCartOnPageShow(event) {
    if (event.persisted) return true;
    try {
      var list = performance.getEntriesByType && performance.getEntriesByType('navigation');
      var nav = list && list[0];
      if (nav && nav.type === 'back_forward') return true;
    } catch (e) {}
    try {
      var pn = performance.navigation;
      if (pn && typeof pn.type === 'number' && pn.type === 2) return true;
    } catch (e2) {}
    return false;
  }

  function syncAfterRestoredFromCache() {
    var onCartPath = isCartPath();

    if (onCartPath) clearStuckCartUiState();
    setCartBubbleSuppress(true);

    var cartRefresh = Promise.resolve();
    if (onCartPath) {
      cartRefresh = isCartPage() ? window.ds2RefreshCartPage() : reinitCartQuantityUi();
    }

    Promise.all([window.ds2RefreshHeaderCartIcon(), cartRefresh])
      .catch(function () {})
      .finally(function () {
        setCartBubbleSuppress(false);
        setCartPageSyncing(false);
        if (onCartPath) clearStuckCartUiState();
      });

    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        window.ds2SyncPremVisualizationCartFlags(cart);
        if (typeof window.ds2ApplyPremFreeRibbonVisibility === 'function') {
          window.ds2ApplyPremFreeRibbonVisibility();
        }
      })
      .catch(function () {});
  }

  window.addEventListener('pageshow', function (event) {
    if (!shouldSyncCartOnPageShow(event)) return;
    syncAfterRestoredFromCache();
  });
})();
